import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error module is untyped

import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelBody from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelHeader';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
import ValidI18nMessage from 'ecosystem-marketplace-core/i18n/components/ValidI18nMessage';
import { selectDisplayedCollections } from '../../../slices/collections/collectionsSlice';
import { getThemesStorefrontRoute } from '../../../utils/urls';
export default function MobileDiscoverPanel({
  onClickItem,
  onClose,
  open
}) {
  const collections = useSelector(selectDisplayedCollections);
  const discoverPanelButtonRef = useRef(null);
  useEffect(() => {
    if (open) {
      discoverPanelButtonRef.current.focus();
    }
  }, [open]);
  return /*#__PURE__*/_jsxs(MobilePanel, {
    open: open,
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      className: "no-flex",
      itemLeft: /*#__PURE__*/_jsx(UIButton, {
        buttonRef: discoverPanelButtonRef,
        className: "m-left-2 p-all-4",
        use: "transparent",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.browsePanel.cancel"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.nav.discover"
      })
    }), /*#__PURE__*/_jsxs(MobilePanelBody, {
      children: [/*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => onClickItem(getThemesStorefrontRoute()),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.nav.allCollections"
        })
      }), collections.map(({
        id,
        publishedListing
      }) => publishedListing && /*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => onClickItem(getThemesStorefrontRoute(publishedListing.slug)),
        title: /*#__PURE__*/_jsx(ValidI18nMessage, {
          defaultValue: publishedListing.title,
          message: `marketplace-assets-ui.collections.collection_${id}.title`
        })
      }, id))]
    })]
  });
}